<template>
  <div class="glass-designer-toolbar-divider">
    {{title}}
  </div>
</template>

<style lang="scss" scoped>
.glass-designer-toolbar-divider {
  width: $editor-toolbar-button-size;
  height: 20px;
  line-height: 20px;
  vertical-align: top;
  font-size: 11px;
  text-align: center;
  color: #8D9CA6;
  text-transform: uppercase;
}
</style>

<script>
export default {
  name: 'ToolbarDivider',
  props: {
    title: String
  }
}
</script>